import React, { useCallback } from 'react';
import { MenuItem, Tooltip } from '@mui/material';
import { VALUATION_APPROACHES_TEST_IDS } from 'pages/ValuationsAllocation/ValuationApproaches.testIds';
import { TabActionOptionProps } from './types';

const TabActionOption = <T, R>(props: TabActionOptionProps<T, R>) => {
  const {
    actionText,
    argumentsList,
    children,
    disabled = false,
    onClick,
    closeApproachMenu,
    tooltipMessage,
    shouldDisplayTooltip = false,
  } = props;

  const onClickHandler = useCallback(() => {
    closeApproachMenu?.();

    if (argumentsList) {
      onClick?.(...argumentsList);
    }
  }, [closeApproachMenu, onClick, argumentsList]);

  return (
    <Tooltip title={shouldDisplayTooltip && tooltipMessage ? tooltipMessage : ''}>
      <span>
        <MenuItem
          data-testid={
            actionText ? VALUATION_APPROACHES_TEST_IDS.approachMenuAction(actionText) : undefined
          }
          disabled={disabled}
          onClick={onClickHandler}>
          {actionText}
          {children}
        </MenuItem>
      </span>
    </Tooltip>
  );
};

export default TabActionOption;
